import React, { Fragment, h} from "preact";
import {AppPage} from '../_common/components/app-page'
import {Card, CF} from '../_common/layout'
import {t} from '../_i18n'
import {useHistory} from 'react-router'
import {connect} from "react-redux";
import {useEffect, useState} from "preact/hooks";
import {getTransferExpedientStatus, uploadTransferExpedientDocument} from "../_rx/transfer-expedient/actions";
import {Select, UploadFile} from "../_common/forms/components/components";
import ButtonSpinner from "../_common/components/buttons/buttonSpinner/buttonSpinner";
import Badge from "../_common/components/Badge";
import {
    TRANSFER_STATUS_VALIDATED,
    TRANSFER_STATUS_REJECTED,
    TRANSFER_STATUS_FINALIZED,
    TRANSFER_STATUS_PENDING_RESOLUTION,
    TRANSFER_STATUS_PENDING_DOCUMENTATION
} from "../constants";

const statusBadgeTextDic = {
    [TRANSFER_STATUS_PENDING_RESOLUTION]: t('Pendiente resolución'),
    [TRANSFER_STATUS_PENDING_DOCUMENTATION]: t('Pendiente documentación'),
    [TRANSFER_STATUS_REJECTED]: t('Rechazado'),
    [TRANSFER_STATUS_VALIDATED]: t('Validado'),
    [TRANSFER_STATUS_FINALIZED]: t('Finalizado')
};
const statusBadgeClassDic = {
    [TRANSFER_STATUS_PENDING_RESOLUTION]: 'badge-warning',
    [TRANSFER_STATUS_PENDING_DOCUMENTATION]: 'badge-warning',
    [TRANSFER_STATUS_REJECTED]: 'badge-danger',
    [TRANSFER_STATUS_VALIDATED]: 'badge-success translucent',
    [TRANSFER_STATUS_FINALIZED]: 'badge-info translucent'
};

const BadgeComponent = ({status, extraClass})=><Badge className={`t-upper width-fit-content badge font-small ${extraClass || ''} ${statusBadgeClassDic[status] || 'd-none'}`}>{t(statusBadgeTextDic[status])}</Badge>


function TransferExpedient({studentId, transferExpedientStatus, enrolledAcademicPrograms, getTransferExpedientStatus, uploadTransferExpedientDocument}) {
    const [file, setFile] = useState(null);
    const [fileURL, setFileURL] = useState('#');
    const [loading, setLoading] = useState(false);
    const academicPrograms = enrolledAcademicPrograms?.filter(ap => ap.formative_zone).map(ap => ({
        name: ap.title + ' ' +  `(${ap.formative_zone_code})`,
        key: ap.id
    }));
    const showMultipleCicles = academicPrograms.length > 1;
    const [academicProgramId, setAcademicProgramId] = useState(academicPrograms[0].key);

    useEffect(async () => {
        await getTransferExpedientStatus(studentId);
    }, []);


    const handleUploadFile = async (event) => {
        let eventFile = event.target.files[0];
        setFile(eventFile);
        setFileURL(URL.createObjectURL(eventFile));
    }

    const handleRemoveFile = () => {
        setFile(null);
        setFileURL('#');
    }

    const handleSubmitFile = async () => {
        setLoading(true);
        await uploadTransferExpedientDocument(studentId, file, academicProgramId);
        await getTransferExpedientStatus(studentId);
        handleRemoveFile();
        setLoading(false);
    }

    const handleAPSelect = (e) => {
        if (e.target.value) setAcademicProgramId(e.target.value);
    }

    const renderRequestCard = (request) => {
        const academicProgram = request.academic_program_translation || enrolledAcademicPrograms.find(ap => ap.academic_program_id)?.title;
        return (
            <Card smOnly={false} className={'m-x2-bottom'}>
                <p className={'font-bold m-r'}>{academicProgram} </p>
                <BadgeComponent extraClass={!request.comments && 'm-bottom'} status={request.status_id} />
                {request.comments &&
                    <Fragment>
                        <p className={'font-color-soft-gray'}>{t('Comentarios')}</p>
                        <p>{request.comments}</p>
                    </Fragment>
                }
            </Card>
        )
    }

    return (
        <CF className="max-width-980 m-x2-top">
            <div dangerouslySetInnerHTML={{__html: t('start_transfer_expedient_request')}}/>
            {showMultipleCicles && (
                <fragment>
                    <div className='font-bold m-top-half'>{t('Selecciona el ciclo que desees traspasar')}:</div>
                    <div className='m-top'>
                        <Select options={academicPrograms} value={academicProgramId} onChange={handleAPSelect} required/>
                    </div>
                </fragment>
            )}
            <div className={'m-top'}>
                <p className={'italic'}>{t('Importante: Un traspaso de expediente no es una convalidación. A continuación puedes ver un par de ejemplos de un certificado de notas parcial.')}</p>
                <ul>
                    <li>
                        <a href="https://storage.googleapis.com/area-onliner/certificado-de-estudio-parciales.png"
                           target='_blank'>{`${t('Ejemplo')} 1`}</a>
                    </li>
                    <li>
                        <a href="https://storage.googleapis.com/area-onliner/certificacion-academica-oficial.png"
                           target='_blank'>{`${t('Ejemplo')} 2`}</a>
                    </li>
                </ul>
            </div>
            <div className='m-top'>
                <p className='font-bold m-bottom'>{t('Certificado de notas parcial')}:</p>
                {!file ?
                    <div className='p-top'>
                        <UploadFile classNameButton='btn btn-ghost m-top m-bottom t-upper'
                                    accept='application/pdf,.docx,.doc,.odt' onChange={handleUploadFile}>
                        {t('Subir archivo')}
                        </UploadFile>
                        <span className='m-top font-color-879CA1'>{t('transfer_expedient_doc_types')}</span>
                    </div>
                    :
                    <div className='m-bottom d-flex flex-column sm-no-flex-column'>
                        <a className='m-r font-color-149BAB m-bottom sm-no-m-bottom' href={fileURL}
                           download={file.name}>{file.name}</a>
                        <span className='cursor-pointer font-color-soft-gray t-underline'
                              onClick={handleRemoveFile}>{t('Quitar archivo')}</span>
                    </div>
                }
            </div>

            <div className='m-x2-top t-upper m-x2-bottom'>
                <ButtonSpinner showSpinner={loading} disabled={!file || !academicProgramId}
                               onClick={handleSubmitFile}>
                    {t('Enviar solicitud')}
                </ButtonSpinner>
            </div>

            { transferExpedientStatus && transferExpedientStatus.length > 0 &&
                <h2 className='m-bottom'>{t('Peticiones anteriores')}</h2>
            }

            { transferExpedientStatus && transferExpedientStatus.length > 0 &&
                transferExpedientStatus.map(request => renderRequestCard(request))
            }
        </CF>
    )

}

TransferExpedient = connect(
    ({auth, transferExpedient, status}) => ({
        studentId: auth.loggedUser.id,
        transferExpedientStatus: transferExpedient.status,
        enrolledAcademicPrograms: status.student_meta.enrolled_academic_programs
    }),
    {getTransferExpedientStatus, uploadTransferExpedientDocument})(TransferExpedient);


export default () => {
    const history = useHistory();
    return (
        <AppPage
            name="traspaso-expediente"
            title={t('Traspaso de expediente')}
            back={history.goBack}
            class="max-width-980">
            <TransferExpedient/>
        </AppPage>
    );
}
